module.exports = __webpack_public_path__ + "static/media/movie.adc41c5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/movie.mp4
// module id = X1D0
// module chunks = 0